/** @format */

import React from 'react';

import {EntityType, ENTITY_TYPE_HEADERS, ENTITY_TYPE_ICONS} from '../constants';
import {SegmentItem} from '../components/ForecastChart';

interface Recommendation {
  entityType: EntityType;
  forecast?: {
    impactKpiValue: number;
    impactBudgetValue: number;
  } | null;
}

export interface RecommendationGroup {
  entityType: EntityType;
  recommendations: Recommendation[];
  totalKpiImpact: number;
  totalBudgetImpact?: number;
}

/**
 * Агрегирует данные из recommendationGroups для графика KPI
 * Суммирует все impactKpiValue для каждого entityType
 */
export function aggregateSegmentData(
  recommendationGroups: readonly RecommendationGroup[],
): SegmentItem[] {
  if (!recommendationGroups || recommendationGroups.length === 0) {
    return [];
  }

  return recommendationGroups.map(group => {
    const {entityType, recommendations} = group;

    // Суммируем все impactKpiValue в рамках одного сегмента
    const totalImpact = recommendations.reduce((sum, rec) => {
      const impactValue = rec.forecast?.impactKpiValue || 0;
      return sum + impactValue;
    }, 0);

    // Получаем иконку и заголовок из констант
    const IconComponent = ENTITY_TYPE_ICONS[entityType];
    const label = ENTITY_TYPE_HEADERS[entityType] || entityType;

    return {
      id: entityType,
      label,
      value: totalImpact,
      icon: IconComponent ? <IconComponent /> : undefined,
    };
  }).sort((a, b) => a.value - b.value);
}

/**
 * Агрегирует данные о бюджете из recommendationGroups для графика
 * Суммирует все impactBudgetValue для каждого entityType
 */
export function aggregateBudgetData(
  recommendationGroups: RecommendationGroup[] | undefined,
): SegmentItem[] {
  if (!recommendationGroups || recommendationGroups.length === 0) {
    return [];
  }

  return recommendationGroups.map(group => {
    const {entityType, recommendations} = group;

    // Суммируем все impactBudgetValue в рамках одного сегмента
    const totalBudgetImpact = recommendations.reduce((sum, rec) => {
      const impactValue = rec.forecast?.impactBudgetValue || 0;
      return sum + impactValue;
    }, 0);

    // Получаем иконку и заголовок из констант
    const IconComponent = ENTITY_TYPE_ICONS[entityType];
    const label = ENTITY_TYPE_HEADERS[entityType] || entityType;

    return {
      id: entityType,
      label,
      value: totalBudgetImpact,
      icon: IconComponent ? <IconComponent /> : undefined,
    };
  }).sort((a, b) => a.value - b.value);
}
